import { AIRTEL_RED } from '../colors';
var flourishConfig = {
  theme: 'light',
  show: true,
  size: 'sm',
  color: AIRTEL_RED,
  config: {
    size: {
      sm: {
        flourishSize: 48
      },
      md: {
        flourishSize: 56
      },
      lg: {
        flourishSize: 64
      }
    }
  }
};
export default {
  light: flourishConfig,
  dark: flourishConfig,
  white: flourishConfig
};